import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'aafp-spinner-inline',
  shadow: false,
})
export class AafpSpinnerInline {
  // Indicate that name should be a public property on the component
  @Prop({ mutable: true }) size: 'sm' | 'md' | 'lg' = 'sm';
  @Prop() actionId: string;
  @Prop() display: 'inline' | 'inline-block' | 'block';

  checkDisplay(display: string) {
    if (display) {
      return `adl-spinner-inline--display-${display}`;
    }
  }

  render() {
    const displayStyle = this.checkDisplay(this.display) || '';
    return (
      <div
        role="status"
        class={`adl-spinner-inline adl-spinner-inline_${this.size} ${displayStyle}`}
        id={this.actionId}
      ></div>
    );
  }
}
